import { Suspense, useEffect, useState } from 'react';
import { lazyWithReload } from '@/lib/lazyWithReload';
import { PANEL_EVENT, type MobilePanel } from '@/lib/mobilePanels';

const CategoryDrawer = lazyWithReload(() => import('./CategoryDrawer').then(module => ({ default: module.CategoryDrawer })));

/** Keep the latest intent while the optional mobile panel downloads. */
export function CategoryDrawerLoader() {
  const [requested, setRequested] = useState(false);
  const [panel, setPanel] = useState<MobilePanel>(null);
  useEffect(() => {
    const update = (event: Event) => {
      const next = (event as CustomEvent<MobilePanel>).detail;
      setPanel(next);
      if (next === 'categories') setRequested(true);
    };
    window.addEventListener(PANEL_EVENT, update);
    return () => window.removeEventListener(PANEL_EVENT, update);
  }, []);

  return requested ? <Suspense fallback={null}><CategoryDrawer panel={panel} /></Suspense> : null;
}
